<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="position: relative;"
      >
        <el-image
          v-if="dialogViewForm.isRealitySettle === 1"
          :src="trulySettleImage"
          class="truly-settle-img"
        />
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="付款单位">
                    <el-input
                      v-model="dialogViewForm.paymentUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="收款单位">
                    <el-input
                      v-model="dialogViewForm.receiveUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款银行">
                    <el-input
                      v-model="dialogViewForm.receiveBankName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款账号">
                    <el-input
                      v-model="dialogViewForm.receiveBankNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="项目编号">
                    <el-input
                      v-model="dialogViewForm.projectNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目名称">
                    <el-input
                      v-model="dialogViewForm.projectName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="季度">
                    <el-input
                      v-model="dialogViewForm.quarter"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="开始时间">
                    <el-date-picker
                      v-model="dialogViewForm.startDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="结束时间">
                    <el-date-picker
                      v-model="dialogViewForm.endDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.schemeId > 0"
                  :span="6"
                >
                  <el-form-item label="方案金额(不含税)">
                    <el-input
                      v-model="dialogViewForm.schemeAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="合同号">
                    <el-input
                      v-model="dialogViewForm.contractNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="结算金额(不含税)">
                    <el-input
                      v-model="dialogViewForm.settleAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="税额">
                    <el-input
                      v-model="dialogViewForm.taxAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="含税金额">
                    <el-input
                      v-model="dialogViewForm.totalAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="中烟结算金额(不含税)">
                    <el-input
                      v-model="dialogViewForm.noTaxCheckAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="中烟结算金额">
                    <el-input
                      v-model="dialogViewForm.checkAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              明细信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:5px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="receivableDetailData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                    show-summary
                    :summary-method="receivableSummaries"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                      fixed="left"
                    />
                    <el-table-column
                      v-if="dialogViewForm.schemeId > 0"
                      prop="typeValue"
                      label="类型"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      prop="itemName"
                      label="名称"
                      width="150"
                      show-overflow-tooltip
                      header-align="center"
                    />
                    <el-table-column
                      prop="itemUnit"
                      label="单位"
                      width="80"
                      align="center"
                    />
                    <!-- <el-table-column
                      prop="realUsedAmount"
                      label="实际数量"
                      width="80"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.realUsedAmount) }}
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      prop="schemeAmount"
                      label="方案数量"
                      width="80"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.typeValue === '管理费' ? scope.row.schemeAmount : formatNumberThousandSeparator(scope.row.schemeAmount) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="itemCount"
                      label="结算数量"
                      width="80"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.itemCount) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="itemPrice"
                      label="单价"
                      width="80"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.itemPrice) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="taxRatePercentage"
                      label="税率"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      prop="amountWithoutTax"
                      label="不含税金额"
                      width="90"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amountWithoutTax) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="amountTax"
                      label="税额"
                      width="90"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amountTax) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="amountIncludingTax"
                      label="含税金额"
                      width="90"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amountIncludingTax) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="itemRemark"
                      label="备注"
                      align="center"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="dialogViewForm.status === 2"
            class="modal-box"
          >
            <h3 class="modal-title">
              收款单信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:5px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="receivedListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                    show-summary
                    :summary-method="receivedSummaries"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                      fixed="left"
                    />
                    <el-table-column
                      prop="receiveDateValue"
                      label="收款日期"
                      width="120"
                      align="center"
                    />
                    <el-table-column
                      prop="voucherNo"
                      label="凭证号"
                      show-overflow-tooltip
                      header-align="center"
                    />
                    <el-table-column
                      prop="amount"
                      label="收款金额"
                      width="150"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amount) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="statusValue"
                      label="收款状态"
                      width="100"
                      align="center"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="dialogViewForm.status === 2"
            class="modal-box"
          >
            <h3 class="modal-title">
              发票信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:5px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="invoiceListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                    show-summary
                    :summary-method="invoiceSummaries"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                      fixed="left"
                    />
                    <el-table-column
                      prop="invoiceNo"
                      label="发票编号"
                      width="200"
                      header-align="center"
                    />
                    <el-table-column
                      prop="invoiceDateValue"
                      label="发票日期"
                      width="120"
                      align="center"
                    />
                    <el-table-column
                      prop="amount"
                      label="发票金额"
                      width="150"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.amount) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="expressDateValue"
                      label="寄出日期"
                      width="120"
                      align="center"
                    />
                    <el-table-column
                      prop="expressNo"
                      label="快递单号"
                      header-align="center"
                    />
                    <el-table-column
                      prop="statusValue"
                      label="发票状态"
                      width="100"
                      align="center"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              附件信息
            </h3>
            <div class="modal-row-box">
              <div class="demo-input-suffix">
                <show-preview :arr-file-data="picList" />
              </div>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              操作备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建人">
                    <el-input
                      v-model="dialogViewForm.creator"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建时间">
                    <el-input
                      v-model="dialogViewForm.createTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="复核人">
                    <el-input
                      v-model="dialogViewForm.checker"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="复核时间">
                    <el-input
                      v-model="dialogViewForm.checkTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { initReceivableApi } from '@/api/receivable'
// 图片预览
import showPreview from '@/components/showPreview'

export default {
  components: { showPreview },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      loadingText: '努力加载数据中，请耐心等待',
      trulySettleImage: require('@/assets/png/trulySettle.png'),

      dialogViewForm: {},
      receivableDetailData: [],
      invoiceListData: [],
      receivedListData: [],
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.receivableDetailData = []
        this.invoiceListData = []
        this.receivedListData = []
        this.dialogViewForm = {}
        this.picList = []

        this.initViewData()
        this.$nextTick(() => {
          this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initViewData() {
      initReceivableApi({ id: this.dataId, type: 'view' }).then(res => {
        const { receivable, detailList, receiveList, invoiceList, fileList } = res.data

        this.dialogViewForm = receivable
        // 金额处理千分位分割符号
        this.dialogViewForm.schemeAmount = this.formatNumberThousandSeparator(this.dialogViewForm.schemeAmount)
        this.dialogViewForm.settleAmount = this.formatNumberThousandSeparator(this.dialogViewForm.settleAmount)
        this.dialogViewForm.taxAmount = this.formatNumberThousandSeparator(this.dialogViewForm.taxAmount)
        this.dialogViewForm.totalAmount = this.formatNumberThousandSeparator(this.dialogViewForm.totalAmount)
        this.dialogViewForm.checkAmount = this.formatNumberThousandSeparator(this.dialogViewForm.checkAmount)
        this.dialogViewForm.noTaxCheckAmount = this.formatNumberThousandSeparator(this.dialogViewForm.noTaxCheckAmount)

        this.receivableDetailData = detailList || []
        this.receivableDetailData.forEach(item => {
          if (item.typeValue === '管理费') {
            item.schemeAmount = '-'
          }
        })
        this.receivedListData = receiveList || []
        this.invoiceListData = invoiceList || []
        //附件相关
        if (fileList.length > 0) {
          fileList.forEach(item => {
            if (item.attachmentUrl.split(',')[1] === 'jpg' || item.attachmentUrl.split(',')[1] === 'jpeg' || item.attachmentUrl.split(',')[1] === 'JPG' || item.attachmentUrl.split(',')[1] === 'JPEG') {
              this.picList.push({
                name: item.attachmentName, url: this.baseUrl + item.attachmentUrl, attachmentName: item.attachmentName, attachmentUrl: item.attachmentUrl
              })
            }
          })
        }
        this.loading = false
      })
    },
    // 应收款明细TABLE合计方法
    receivableSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'itemCount') {
          sums[index] = values.reduce((prev, curr) => {
            return prev + curr
          }, 0)
          sums[index] = this.formatNumberThousandSeparator(sums[index])
        } else if (column.property === 'amountWithoutTax' || column.property === 'amountTax' || column.property === 'amountIncludingTax') {
          sums[index] = values.reduce((prev, curr) => {
            return this.roundNumber((prev + curr), 2)
          }, 0)
          sums[index] = this.formatNumberThousandSeparator(sums[index])
        }
      })
      return sums
    },
    // 收款明细TABLE合计方法
    receivedSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'amount') {
          sums[index] = values.reduce((prev, curr) => {
            return this.roundNumber((prev + curr), 2)
          }, 0)
          sums[index] = this.formatNumberThousandSeparator(sums[index])
        }
      })
      return sums
    },
    // 发票明细TABLE合计方法
    invoiceSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'amount') {
          sums[index] = values.reduce((prev, curr) => {
            return this.roundNumber((prev + curr), 2)
          }, 0)
          sums[index] = this.formatNumberThousandSeparator(sums[index])
        }
      })
      return sums
    },
    // 关闭弹窗
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    }
  }
}
</script>
<style lang="scss"  scoped>
.truly-settle-img {
  width: 10%;
  position: absolute;
  right: 20px;
  top: 0;
  z-index: 9999;
}
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 2px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 2px;
}
::v-deep .special-row .el-col {
  min-height: 20px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
</style>
